import { Reveal, Eyebrow } from "./Reveal";

const STEPS = [
    {
        num: "01",
        title: "We Think",
        desc: "We don't just make things look good. We think about your audience, your message, and what you want your brand to accomplish.",
        accent: "#D3A0A7",
    },
    {
        num: "02",
        title: "We Create",
        desc: "From the first concept to the final graphic, we turn ideas into visuals people actually want to look at.",
        accent: "#A9C6DE",
    },
    {
        num: "03",
        title: "We Build",
        desc: "We create cohesive branding and marketing pieces that make your brand feel like a real, recognizable business.",
        accent: "#D3A0A7",
    },
];

export const Process = () => (
    <section
        data-testid="process-section"
        className="py-20 md:py-32 px-5 sm:px-8 lg:px-12 bg-[#0C0C0C] border border-[#262626] rounded-[2.5rem] mx-3 md:mx-6 my-6"
    >
        <div className="max-w-7xl mx-auto">
            <div className="text-center max-w-2xl mx-auto mb-14 md:mb-20">
                <Reveal>
                    <Eyebrow>Not just pretty.</Eyebrow>
                </Reveal>
                <Reveal delay={0.1}>
                    <h2 className="mt-4 font-serif-ed text-3xl sm:text-4xl lg:text-5xl leading-[1.12] tracking-tight text-[#F1F1EF]">
                        Purposeful.
                    </h2>
                </Reveal>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-5 lg:gap-6">
                {STEPS.map((s, i) => (
                    <Reveal key={s.num} delay={i * 0.12} className="h-full">
                        <div
                            data-testid={`process-step-${s.num}`}
                            className="relative bg-[#161616] rounded-3xl p-9 md:p-10 h-full border border-[#262626] overflow-hidden"
                        >
                            <span
                                aria-hidden="true"
                                className="absolute -top-6 -right-2 font-serif-ed font-bold text-[7rem] leading-none text-[#F1F1EF]/[0.06] select-none"
                            >
                                {s.num}
                            </span>
                            <span
                                className="font-serif-ed italic text-lg"
                                style={{ color: s.accent }}
                            >
                                {s.num}
                            </span>
                            <h3 className="mt-14 md:mt-20 font-serif-ed text-3xl tracking-tight text-[#F1F1EF]">
                                {s.title}
                            </h3>
                            <p className="mt-3 text-sm md:text-base leading-relaxed text-[#A9A6A0]">
                                {s.desc}
                            </p>
                        </div>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
